import { makeAutoObservable, runInAction } from 'mobx'
import { notification } from 'antd'
import { openApi } from '../../../helpers/request'
import i from '../../../translations/i'
import __multiple from '../../../helpers/multiple_actions/__multiple'

interface FiltersInterface {
    entity_type: string | null
    status: string | null
    rating: number | null
    has_photo: number | null
    viewed: number | null
    date_from: number | null
    date_to: number | null
    user_id: number | null
    search: string | null
}

class reviewsController {

    list: any[] = []
    review: any = null

    notViewed: number = 0
    stats: any = null

    filters: FiltersInterface = {
        entity_type: null,
        status: null,
        rating: null,
        has_photo: null,
        viewed: null,
        date_from: null,
        date_to: null,
        user_id: null,
        search: null
    }

    sorting = {
        type: 'id',
        action: 'desc'
    }

    pagination = {
        total: 0,
        limit: 10,
        page: 1
    }

    reply: string = ''
    rejectReason: string = ''

    constructor() {
        makeAutoObservable(this)
    }

    private query(): string {
        let path = `/reviews?limit=${this.pagination.limit}&page=${this.pagination.page}`
        path += `&sorting_type=${this.sorting.type}&sorting_action=${this.sorting.action}`

        Object.keys(this.filters).map((key: string) => {
            // @ts-ignore
            const value = this.filters[key]
            if(value !== null && value !== '') path += `&filter[${key}]=${encodeURIComponent(value)}`
        })

        return path
    }

    get(sorter: any = false) {
        if(sorter !== false && sorter.order !== undefined) {
            this.sorting.type = sorter.columnKey
            this.sorting.action = sorter.order === 'ascend' ? 'asc' : 'desc'
        }

        openApi('get', this.query())
            .then(result => runInAction(() => {
                this.list = result.data
                this.pagination.total = result.total
                this.pagination.page = result.page
                this.pagination.limit = result.limit
                this.notViewed = result.not_viewed ?? 0
                this.stats = result.stats ?? null
            }))
            .catch(err => console.log(err.response))
    }

    getOne(id: string | number) {
        openApi('get', `/reviews/${id}`)
            .then(result => runInAction(() => {
                this.review = result.data
                this.reply = result.data.replyText ?? ''
                this.rejectReason = ''
            }))
            .catch(err => console.log(err.response))
    }

    setFilter(key: string, value: any) {
        // @ts-ignore
        this.filters[key] = value === undefined ? null : value
        this.pagination.page = 1
        this.get()
    }

    /** Ставит несколько фильтров сразу — иначе диапазон дат уходил бы двумя запросами */
    setFilters(values: Record<string, any>) {
        Object.keys(values).map((key: string) => {
            // @ts-ignore
            this.filters[key] = values[key] === undefined ? null : values[key]
            return null
        })
        this.pagination.page = 1
        this.get()
    }

    setPage(page: number) {
        this.pagination.page = page
        this.get()
    }

    /**
     * Одобрение и отклонение. Если у отзыва висит правка, действие применяется
     * к ней: одобрение переносит правку в отзыв, отклонение оставляет
     * опубликованную версию как есть.
     */
    moderate(ids: number[], action: 'approve' | 'reject', reload: 'list' | 'one' = 'list') {
        if(ids.length === 0) return

        const data = new FormData()
        ids.map((id: number) => data.append('ids[]', `${id}`))
        data.append('action', action)
        if(action === 'reject' && this.rejectReason !== '') data.append('reason', this.rejectReason)

        openApi('post', '/reviews/moderate', data)
            .then(() => {
                notification.success({
                    message: i.t('def:success.complete'),
                    description: i.t('def:success.edit')
                })

                __multiple.clear()

                if(reload === 'one') this.getOne(ids[0])
                else this.get()
            })
            .catch(err => console.log(err.response))
    }

    saveReply(id: number) {
        const data = new FormData()
        data.append('text', this.reply)

        openApi('post', `/reviews/reply/${id}`, data)
            .then(() => {
                notification.success({
                    message: i.t('def:success.complete'),
                    description: i.t('def:success.edit')
                })
                this.getOne(id)
            })
            .catch(err => console.log(err.response))
    }

    multipleRead() {
        const data = new FormData()
        __multiple.selected.map((el: number) => data.append('ids[]', `${el}`))

        openApi('post', '/reviews/read', data)
            .then(() => {
                __multiple.clear()
                this.get()
            })
    }

    multipleModerate(action: 'approve' | 'reject') {
        this.moderate(__multiple.selected, action)
    }

    multipleDelete() {
        const data = new FormData()
        __multiple.selected.map((el: number) => data.append('ids[]', `${el}`))

        openApi('post', '/reviews/delete/multiple', data)
            .then(() => {
                __multiple.clear()
                this.get()
            })
    }

    remove(id: number, backToList: boolean = false) {
        if(window.confirm(i.t('def:confirms.delete'))) {
            openApi('delete', `/reviews/${id}`)
                .then(() => {
                    if(backToList) window.location.href = '/shop/reviews'
                    else this.get()
                })
        }
    }

    export(type: string = 'xlsx') {
        openApi('get', `/reviews/export/${type}`)
            .then(result => {
                if(result.data) window.open(result.data, '_blank')
            })
            .catch(err => console.log(err.response))
    }

    set(name: string, value: any) {
        // @ts-ignore
        this[name] = value
    }
}

export default new reviewsController()
